import {
  CALCULATE_DEBT_LOAD_REQUEST,
  DEBTLOAD_LIST_FAILED,
  DEBTLOAD_LIST_REQUEST,
  DEBTLOAD_LIST_SUCCESS,
  FETCH_DEBT_LOAD_CALCULATE_FAILED,
  FETCH_DEBT_LOAD_CALCULATE_REQUEST,
  FETCH_DEBT_LOAD_CALCULATE_SUCCESS,
  FETCH_DEBT_LOAD_REPORT_FAILED,
  FETCH_DEBT_LOAD_REPORT_REQUEST,
  FETCH_DEBT_LOAD_REPORT_SUCCESS,
  GET_CLIENT_LAST_DEBT_LOAD_FAILED,
  GET_CLIENT_LAST_DEBT_LOAD_REQUEST,
  GET_CLIENT_LAST_DEBT_LOAD_SUCCESS,
  GET_DEBT_LOAD_GROUP_REQUEST,
  GET_DEBT_LOAD_GROUP_SUCCESS,
  IS_SIGNED_NOTIFICATION,
  RESET_DEBT_LOAD_CALCULATE,
  UPDATE_DEBT_LOAD_GROUP_FAILURE,
  UPDATE_DEBT_LOAD_GROUP_REQUEST,
  UPDATE_DEBT_LOAD_GROUP_SUCCESS,
} from "../actions/actionTypes";

const initialState = {
  debtLoadList: [],
  debtLoadGroup: [],
  loading: false,
  commonError: false,
  updateError: null,
  debtCalculateError: null,
  debtLoadCalculation: null,
  debtLoadCalculationLoading: false,
  clientDebtLoadData: null,
  debtLoadReportData: null,
  debtReportLoading: false,
  debtLoadReportError: null,
  clientDebtLoadError: null,
  isSignedNotification: false,
};

const debtLoadReducer = (state = initialState, action) => {
  switch (action.type) {
    case DEBTLOAD_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        commonError: false,
      };
    case DEBTLOAD_LIST_SUCCESS:
      return {
        ...state,
        debtLoadList: action.payload,
        loading: false,
        commonError: false,
      };
    case DEBTLOAD_LIST_FAILED:
      return {
        ...state,
        loading: false,
        commonError: action.payload,
      };
    case GET_DEBT_LOAD_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
        commonError: false,
      };
    case GET_DEBT_LOAD_GROUP_SUCCESS:
      return {
        ...state,
        debtLoadGroup: action.payload,
        loading: false,
        commonError: false,
      };
    case UPDATE_DEBT_LOAD_GROUP_REQUEST:
      return {
        ...state,
        updating: true,
        updateError: null,
      };
    case UPDATE_DEBT_LOAD_GROUP_SUCCESS:
      return {
        ...state,
        updateError: null,
      };
    case UPDATE_DEBT_LOAD_GROUP_FAILURE:
      return {
        ...state,
        updateError: action.payload,
      };
    case CALCULATE_DEBT_LOAD_REQUEST:
      return {
        ...state,
        debtLoadCalculationLoading: true,
        debtCalculateError: null,
      };
    case FETCH_DEBT_LOAD_CALCULATE_REQUEST:
      return {
        ...state,
        debtLoadCalculationLoading: true,
        debtCalculateError: null,
      };
    case FETCH_DEBT_LOAD_CALCULATE_SUCCESS:
      return {
        ...state,
        debtLoadCalculation: action.payload,
        debtLoadCalculationLoading: false,
        debtCalculateError: null,
      };
    case FETCH_DEBT_LOAD_CALCULATE_FAILED:
      return {
        ...state,
        debtCalculateError: action.payload,
        debtLoadCalculationLoading: false,
        debtLoadCalculation: null,
      };
    case RESET_DEBT_LOAD_CALCULATE:
      return {
        ...state,
        debtCalculateError: null,
        debtLoadCalculation: null,
      };
    case GET_CLIENT_LAST_DEBT_LOAD_REQUEST:
      return {
        ...state,
        clientDebtLoadError: null,
        loading: true,
      };
    case GET_CLIENT_LAST_DEBT_LOAD_SUCCESS:
      return {
        ...state,
        clientDebtLoadData: action.payload,
        loading: false,
        clientDebtLoadError: null,
      };
    case GET_CLIENT_LAST_DEBT_LOAD_FAILED:
      return {
        ...state,
        clientDebtLoadError: action.payload,
        loading: false,
      };
    case IS_SIGNED_NOTIFICATION:
      return {
        ...state,
        isSignedNotification: action.payload,
      };
    case FETCH_DEBT_LOAD_REPORT_REQUEST:
      return {
        ...state,
        debtLoadReportData: null,
        debtReportLoading: true,
        debtLoadReportError: null,
      };
    case FETCH_DEBT_LOAD_REPORT_SUCCESS:
      return {
        ...state,
        debtLoadReportData: action.payload,
        debtReportLoading: false,
        debtLoadReportError: null,
      };
    case FETCH_DEBT_LOAD_REPORT_FAILED:
      return {
        ...state,
        debtLoadReportData: null,
        debtLoadReportError: action.payload,
        debtReportLoading: false,
      };
    default:
      return state;
  }
};

export default debtLoadReducer;
